export default class {
  private items: Array<{
    action: () => any;
    resolve: (value: any | PromiseLike<any>) => void;
    reject: (reason?: any) => void;
  }>;

  private hasPendingItem: boolean;

  constructor() {
    this.items = [];
    this.hasPendingItem = false;
  }

  add<T>(action: () => Promise<T>) {
    return new Promise<T>((resolve, reject) => {
      this.items.push({
        action,
        resolve,
        reject,
      });

      this.run();
    });
  }

  private async run() {
    if (this.hasPendingItem) {
      return;
    }

    const item = this.items.shift();

    if (!item) {
      return;
    }

    this.hasPendingItem = true;

    try {
      item.resolve(await item.action());
    } catch (e) {
      item.reject(e);
    } finally {
      this.hasPendingItem = false;
      this.run();
    }
  }
}
